import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import isEmpty from 'lodash/isEmpty'
import { FlexContainer, Button } from 'heliocor-ui'
import { useTranslation } from 'react-i18next';

const List = styled.ul(({
    theme: { colors }
}) => css`
    font-size: 14px; 
    line-height: 16px; 
    list-style: none; 
    margin-left: 0; 
    padding-left: 1em; 
    text-indent: -1em; 
    li:before { 
        padding-right: .25rem;
        content: "» "; 
    }
`)


const ErrorList = ({ errors, sendForManualValidation, sentForManualValidation, onRetryClicked, showRetry, documentType}) => {
    const { t } = useTranslation()

    if (isEmpty(errors)) return null

    return (
        <Fragment>
            <List>
                {errors.map((err, i) => (
                    <li key={i}>
                        {t(`warning.${err}`)}
                    </li>
                ))
                }
            </List>
            <FlexContainer justifyContent='flex-end'>
                {(!sentForManualValidation && showRetry) &&
                    <Button
                        disabled={sentForManualValidation}
                        value={t('button.tryAgain')}
                        onClick={() => onRetryClicked(documentType)}
                        type={errors.find(e => e === 'VALIDATED_AUTOMATICALLY') ? 'light' : 'default'}
                    />
                }
            </FlexContainer>
            <FlexContainer justifyContent='flex-end' margin='0 -16px 0'>
                {!errors.some(reason => ['UNKNOWN_ERROR', 'NOT_VALIDATED', 'VALIDATED_AUTOMATICALLY'].includes(reason)) && !sentForManualValidation &&
                    <Button
                        value={t(sentForManualValidation ? 'button.sentForManual' : 'button.sendForManual')}
                        onClick={() => sendForManualValidation(documentType)}
                        disabled={sentForManualValidation}
                        type='light'
                        data-cy='manualValidation'
                    />
                }
            </FlexContainer>
        </Fragment>
    )
}

export { ErrorList }